import isEqual from 'lodash/isEqual';
import {useState, useEffect, useCallback} from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  GridActionsCellItem,
  GridToolbarContainer,
  GridRowSelectionModel,
  GridToolbarQuickFilter,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridColumnVisibilityModel,
  GridRowId
} from '@mui/x-data-grid';

import {paths} from 'src/routes/paths';
import {useRouter} from 'src/routes/hooks';
import {useBoolean} from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import {useSnackbar} from 'src/components/snackbar';
import EmptyContent from 'src/components/empty-content';
import {ConfirmDialog} from 'src/components/custom-dialog';
import {
  IProductTableFilters,
  IProductTableFilterValue
} from 'src/types/product';

import {
  RenderCellPublish,
  RenderCellProduct,
  RenderCellCreatedAt
} from './cmsDatagridfunctions/product-table-row';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {Box, LinearProgress, Tooltip} from '@mui/material';

// ----------------------------------------------------------------------
interface CourseTableData {
  id: string;
  Code: string;
  CourseName: string;
  CourseType: string;
  Duration: string;
  CreatedAt: Date | number | string;
  ModifiedAt: Date | number | string;
  CreatedBy: string;
  publish: string;
  ModifiedBy: string;
}
const PUBLISH_OPTIONS = [
  {value: 'PUBLISHED', label: 'PUBLISHED'},
  {value: 'DRAFTED', label: 'DRAFTED'}
];

const defaultFilters: IProductTableFilters = {
  publish: [],
  stock: []
};

const HIDE_COLUMNS = {
  category: false
};

const HIDE_COLUMNS_TOGGLABLE = ['category', 'actions'];
type props = {
  products: CourseTableData[];
  handleEditUser?: (data: any) => void;
  handleViewUser?: (data: any, type: string) => void;
  handleDeleteUser?: (data: any) => void;
  handlePublishChange?: (id: string) => void;
  tableViewFormat: boolean;
  loaders: boolean;
  tableKey: string;
  paginationModel: {page: number; pageSize: number};
  onPaginationModelChange: (
    key: string,
    model: {page: number; pageSize: number}
  ) => void;
  totalRowCount?: number;
};
// ----------------------------------------------------------------------

export default function ProductListView(props: props): JSX.Element {
  const {enqueueSnackbar} = useSnackbar();

  const confirmRows = useBoolean();

  const router = useRouter();
  const {
    handleEditUser,
    products,
    handleDeleteUser,
    handlePublishChange,
    handleViewUser,
    tableKey,
    paginationModel,
    onPaginationModelChange,
    loaders,
    totalRowCount = 0
  } = props;
  const [tableData, setTableData] = useState<CourseTableData[]>(products);
  const [filters, setFilters] = useState(defaultFilters);

  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(HIDE_COLUMNS);

  useEffect(() => {
    if (products.length) {
      setTableData(products);
    }
  }, [products]);

  const dataFiltered = applyFilter({
    inputData: tableData,
    filters
  });
  // useEffect(() => {
  //   // Trigger your API call with paginationModel.pageSize and paginationModel.page
  //   fetchDataWithPagination(paginationModel.pageSize, paginationModel.page);
  // }, [paginationModel]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const canReset = !isEqual(defaultFilters, filters);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFilters = useCallback(
    (name: string, value: IProductTableFilterValue) => {
      setFilters(prevState => ({
        ...prevState,
        [name]: value
      }));
    },
    []
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleResetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);
  const deleteUser = (data: any) => {
    if (handleDeleteUser && typeof handleDeleteUser === 'function') {
      handleDeleteUser(data);
    }
  };
  // const PublishChange = (data: any) => {
  //   if (handlePublishChange && typeof handlePublishChange === 'function') {
  //     handlePublishChange(data);
  //   }
  // };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const PublishChangess = (data: any) => {
    if (handlePublishChange && typeof handlePublishChange === 'function') {
      handlePublishChange(data);
    }
  };

  //   const handleDeleteRow = useCallback(
  //     (id: string) => {
  //       const deleteRow = tableData.filter(row => row.id !== id);

  //       enqueueSnackbar('Delete success!');

  //       setTableData(deleteRow);
  //     },
  //     [enqueueSnackbar, tableData]
  //   );

  const handleDeleteRows = useCallback(() => {
    const deleteRows = tableData.filter(
      row => !selectedRowIds.includes(row.id)
    );

    enqueueSnackbar('Delete success!');

    setTableData(deleteRows);
  }, [enqueueSnackbar, selectedRowIds, tableData]);

  const editUser = (data: any): void => {
    if (handleEditUser && typeof handleEditUser === 'function') {
      handleEditUser(data);
    }
  };
  const handleViewUserData = (data: any, type: string): void => {
    if (handleViewUser && typeof handleViewUser === 'function') {
      handleViewUser(data, type);
    }
  };
  const handlePublishChangeesss = (newValue: any, id: GridRowId) => {
    console.log('Publish status changed to:', newValue, 'for ID:', id);
    // Implement your logic to handle the change, e.g., updating the backend
  };
  const getPublishValue = (params: {
    row: {[x: string]: any};
    field: string | number;
  }) => {
    // Assume you need to transform or compute the value to be displayed or used
    return params.row[params.field];
  };

  // const handleViewRow = useCallback(
  //   (id: string) => {
  //     router.push(paths.dashboard.product.details(id));
  //   },
  //   [router]
  // );

  const columns: GridColDef[] = [
    {
      field: 'Code',
      headerName: 'Course Code',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CourseName',
      headerName: 'Course Name',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CourseType',
      headerName: 'Course Type',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'Duration',
      headerName: 'Duration',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CreatedAt',
      headerName: 'Create At',
      renderCell: params => <RenderCellCreatedAt params={params} />
    },
    {
      field: 'ModifiedAt',
      headerName: 'Modified At',
      renderCell: params => <RenderCellCreatedAt params={params} />
    },
    {
      field: 'CreatedBy',
      headerName: 'Created By',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'ModifiedBy',
      headerName: 'Modified By',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'Ispublished',
      headerName: 'Publish',
      // type: 'singleSelect',
      // editable: true,
      // valueOptions: PUBLISH_OPTIONS,
      // valueGetter: getPublishValue,
      renderCell: params => (
        <RenderCellPublish
          params={params}
          // onChange={(event: {target: {value: any}}) =>
          //   handlePublishChangeesss(event.target.value, params.id)
          // }
        />
      )
    },
    {
      type: 'actions',
      field: 'actions',
      headerName: ' ',
      align: 'right',
      headerAlign: 'right',
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      getActions: params => [
        <GridActionsCellItem
          key={params.row.id}
          showInMenu
          icon={<Iconify icon="solar:eye-bold" />}
          label="View"
          onClick={() => handleViewUserData(params.row.id, 'Admin')}
        />,
        <GridActionsCellItem
          key={params.row.id}
          showInMenu
          icon={<Iconify icon="solar:pen-bold" />}
          label="Edit"
          onClick={() => editUser(params.row.id)}
        />,
        <GridActionsCellItem
          key={params.row.id}
          showInMenu
          icon={<Iconify icon="solar:trash-bin-trash-bold" />}
          label="Delete"
          onClick={() => {
            deleteUser(params.row.id);
          }}
          sx={{color: 'error.main'}}
        />
      ]
    }
  ];
  const columnForUser: GridColDef[] = [
    {
      field: 'Code',
      headerName: 'Course Code',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CourseName',
      headerName: 'Course Name',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CourseType',
      headerName: 'Course Type',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'Duration',
      headerName: 'Duration',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'CreatedBy',
      headerName: 'Created By',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    {
      field: 'ModifiedBy',
      headerName: 'Modified By',
      flex: 1,
      hideable: false,
      renderCell: params => <RenderCellProduct params={params} />
    },
    // {
    //   field: 'Ispublished',
    //   headerName: 'Publish',
    //   type: 'singleSelect',
    //   editable: true,
    //   valueOptions: PUBLISH_OPTIONS,
    //   valueGetter: getPublishValue,
    //   renderCell: params => (
    //     <RenderCellPublish
    //       params={params}
    //       onChange={(event: {target: {value: any}}) =>
    //         handlePublishChangeesss(event.target.value, params.id)
    //       }
    //     />
    //   )
    // },
    {
      field: 'CompletionPercentage',
      headerName: 'Progress',
      flex: 1,
      hideable: false,
      renderCell: params => {
        const value = Number(params.value); // e.g., 0 to 100
        return (
          <Tooltip title={`${value}%`}>
            <Box sx={{width: '100%', px: 1}}>
              <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                  height: 8,
                  borderRadius: 5,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor:
                      value === 100 ? 'success.main' : 'primary.main'
                  }
                }}
              />
            </Box>
          </Tooltip>
        );
      }
    },
    {
      type: 'actions',
      field: 'actions',
      headerName: 'Action',
      align: 'left',
      headerAlign: 'left',
      flex: 1,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: params => [
        // <Box
        //   key={params.row.id}
        //   sx={{
        //     '& .MuiListItemIcon-root': {
        //       minWidth: 'unset',
        //       marginRight: '8px'
        //     }
        //   }}>
        //   <GridActionsCellItem
        //     key={params.row.id}
        //     showInMenu
        //     icon={<Iconify icon="solar:eye-bold" />}
        //     label="View"
        //     onClick={() => handleViewUserData(params.row.id)}
        //   />
        // </Box>
        <GridActionsCellItem
          key={params.row.id}
          showInMenu
          icon={<Iconify icon="solar:eye-bold" />}
          label="View"
          onClick={() => handleViewUserData(params.row.id, 'User')}
          sx={{
            '& .MuiListItemIcon-root': {
              minWidth: 'unset',
              marginRight: '8px'
            }
          }}
        />
      ]
    }
  ];

  const getTogglableColumns = () =>
    props.tableViewFormat
      ? columns
          .filter(column => !HIDE_COLUMNS_TOGGLABLE.includes(column.field))
          .map(column => column.field)
      : columnForUser
          .filter(column => !HIDE_COLUMNS_TOGGLABLE.includes(column.field))
          .map(column => column.field);

  return (
    <>
      <Card
        sx={{
          marginTop: '4vh',
          height: '54vh',
          flexGrow: {md: 1},
          display: {md: 'flex'},
          flexDirection: {md: 'column'}
        }}>
        {loaders ? (
          <Stack
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            minHeight={'50vh'}>
            <LoadingScreen />
          </Stack>
        ) : (
          <DataGrid
            checkboxSelection={false}
            disableRowSelectionOnClick
            rows={dataFiltered}
            columns={props.tableViewFormat ? columns : columnForUser}
            // loading={productsLoading}
            getRowHeight={() => 'auto'}
            pageSizeOptions={[5, 10, 25]}
            paginationModel={paginationModel}
            onPaginationModelChange={model => {
              onPaginationModelChange(tableKey, model);
            }}
            paginationMode="server"
            rowCount={totalRowCount}
            initialState={{
              pagination: {
                paginationModel: {pageSize: 10}
              }
            }}
            onRowSelectionModelChange={newSelectionModel => {
              setSelectedRowIds(newSelectionModel);
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={newModel =>
              setColumnVisibilityModel(newModel)
            }
            slots={{
              toolbar: () => (
                <>
                  <GridToolbarContainer>
                    <GridToolbarQuickFilter />

                    <Stack
                      spacing={1}
                      flexGrow={1}
                      direction="row"
                      alignItems="center"
                      justifyContent="flex-end">
                      <GridToolbarColumnsButton />
                      <GridToolbarFilterButton />
                      {/* <GridToolbarExport /> */}
                    </Stack>
                  </GridToolbarContainer>

                  {/* {canReset && (
                    <ProductTableFiltersResult
                      filters={filters}
                      onFilters={handleFilters}
                      onResetFilters={handleResetFilters}
                      results={dataFiltered.length}
                      sx={{p: 2.5, pt: 0}}
                    />
                  )} */}
                </>
              ),
              noRowsOverlay: () => <EmptyContent title="No Data" />,
              noResultsOverlay: () => <EmptyContent title="No results found" />
            }}
            slotProps={{
              columnsPanel: {
                getTogglableColumns
              }
            }}
          />
        )}
      </Card>

      <ConfirmDialog
        open={confirmRows.value}
        onClose={confirmRows.onFalse}
        title="Delete"
        content={
          <>
            Are you sure want to delete{' '}
            <strong> {selectedRowIds.length} </strong> items?
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleDeleteRows();
              confirmRows.onFalse();
            }}>
            Delete
          </Button>
        }
      />
    </>
  );
}

// ----------------------------------------------------------------------

function applyFilter({
  inputData,
  filters
}: {
  inputData: CourseTableData[];
  filters: IProductTableFilters;
}) {
  const {stock, publish} = filters;

  if (stock.length) {
    inputData = inputData.filter(product => stock.includes(product.Code));
  }

  if (publish.length) {
    inputData = inputData.filter(product => publish.includes(product.publish));
  }

  return inputData;
}
